export default [
  {
    content: {
      title: '<span class="title__line"><span class="title__letter">D</span><span class="title__letter">I</span><span class="title__letter">E</span><span class="title__letter">S</span><span class="title__letter">E</span><span class="title__letter">L</span></span><br /><span class="title__line"><span class="title__letter">W</span><span class="title__letter">Y</span><span class="title__letter">N</span><span class="title__letter">W</span><span class="title__letter">O</span><span class="title__letter">O</span><span class="title__letter">D</span></span>',
    },
  },
  {
    content: {
      image: '/static/images/real_estate/diesel_wynwood_img1.jpg',
      eyelet: 'Diesel Wynwood Condominium',
    },
  },
  {
    content: {
      subtitle: 'El distrito Wynwood de Miami alberga el proyecto más grande y ambicioso de Diesel Living, desarrollado por Bel Invest.',
      text: 'Una visión de lo que puede ser la vida metropolitana. Enriquecido por una gran cantidad de comodidades, entre las que se incluyen una piscina contemporánea, gimnasio, sala de meditación, una galería de arte y un exuberante patio, los elementos de hormigón dorado de Diesel Wynwood se complementan finamente con la vegetación tropical del edificio. La esencia de Diesel: un espacio de lujo total, confort y diseño de vanguardia.',
    },
  },
  {
    content: {
      title: '<span class="title__line">UNA SIMBIOSIS</span><br /><span class="title__line">ENTRE LA</span><br><span class="title__line">NATURALEZA Y</span><br /><span class="title__line">LA CIUDAD PARA</span><br/><span class="title__line">LA VIDA MODERNA</span><br /><span class="title__line">DE LOS HABITANTES</span><br /><span class="title__line">OF CONTEMPORARY</span><br /><span class="title__line">URBANOS CONTEMPORÁNEOS.</span>',
    },
  },
  {
    content: [
      {
        title: '¿El vecindario?',
        text: 'Wynwood es una de las zonas más populares de los EE. UU. Cushman y Wakefield lo atestiguan. Pero estamos seguros de que un paseo por la cuadra te hará sentir lo mismo.',
      },
      {
        title: 'Naturaleza y ciudad.',
        text: 'Aportando luz y naturaleza a los espacios habitables. Una residencia contemporánea donde el paisaje post-industrial que lo rodea se fusiona con la cercanía de la naturaleza.',
      },
    ],
  },
  {
    content: {
      image: '/static/images/real_estate/diesel_wynwood_img2.jpg',
      is3d: true,
      eyelet: 'Diesel Wynwood - 360° Experience',
    },
  },
  {
    content: {
      title: 'DIESEL WYNWOOD',
      text: 'En línea con el extraordinario desarrollo de Wynwood, la ciudad emitió recientemente un nuevo plan de zonificación, que hará que Wynwood se convierta en el vecindario más urbano y amigable para los peatones de la ciudad. El nuevo Soho de Miami. 143 espacios de diseño exclusivo representados en un tono claro u oscuro de acuerdo con la orientación de su edificio, desde estudios hasta apartamentos penthouse y dúplex.',
    },
  },
  {
    content: {
      title: 'TEMPORADA DE PRE-VENTA EN DIESEL WYNWOOD',
    },
  },
  {
    content: [
      {
        content: {
          image: '/static/images/real_estate/diesel_wynwood_img3.jpg',
          title: 'APT. A1-L4.<br />STUDIO<br />395 SQ.FT',
          price: '$ 399.000',
        },
      },
      {
        content: {
          image: '/static/images/real_estate/diesel_wynwood_img4.jpg',
          title: 'APT. D6-L4<br />2 BDRM<br />1.118 SQ.FT',
          price: '$ 949.000',
        },
      },
      {
        content: {
          image: '/static/images/real_estate/diesel_wynwood_img5.jpg',
          title: 'APT. E4-L4<br />2 BDRM + DEN<br />1.467 SQ.FT',
          price: '$ 1.399.000',
        },
      },
    ],
  },
  {
    content: {
      image: '/static/images/real_estate/diesel_wynwood_img6.jpg',
    },
  },
  {
    content: [
      {
        content: {
          image: '/static/images/real_estate/diesel_wynwood_img7.jpg',
          title: 'APT. F1-L6<br />3 BDRM<br />1.538 SQ.FT',
          price: '$ 1.599.000',
        },
      },
      {
        content: {
          image: '/static/images/real_estate/diesel_wynwood_img8.jpg',
          title: 'APT. F2-L8<br />PENTHOUSE<br />3.021 SQ.FT',
          price: '$ 5.500.000',
        },
      },
    ],
  },
  {
    content: {
      title: 'TEMPORADA DE PRE-VENTA EN DIESEL WYNWOOD',
    },
  },
  {
    content: {
      title: '<span class="title__line">COMBINACIÓN</span><br><span class="title__line">DE LUJO CON</span><br /><span class="title__line">NATURALEZAY PAISAJE</span><br /><span class="title__line">POST-INDUSTRIAL EN</span><br /><span class="title__line">EN UNAESTÉTICA</span><br /><span class="title__line">MODERNA Y DINÁMICA</span>',
    },
  },
  {
    content: {
      subtitle: 'Las personas desean un estilo de vida más urbano, sin compromisos. Diesel Wynwood es la respuesta.',
      text: 'Arte y negocios, hoteles, oficinas prósperas de la nueva economía, emocionantes tiendas, restaurantes elegantes, así como otros residenciales y entretenimiento de calidad.Estos son solo algunos de los elementos de la nueva y vibrante vida urbana de Wynwood.Un hogar único que reúne a las personas más hábiles, centradas en el futuro e imaginativas para vivir en este enclave moderno.',
    },
  },
  {
    content: {
      image: '/static/images/real_estate/diesel_wynwood_img9.jpg',
    },
  },
  {
    content: {
      title: '<span class="title__line"><span class="title__letter">C</span><span class="title__letter">O</span><span class="title__letter">N</span><span class="title__letter">T</span><span class="title__letter">A</span><span class="title__letter">C</span><span class="title__letter">T</span></span>',
    },
  },
];
